import type { IndustryPresetKey } from "@/data/industryPresets";
import type { IndustryPreset } from "@/shared/types/industryPreset";

/** Homepage niche switcher key → lead/onboard IndustryPreset enum */
export const LEAD_PRESET_BY_KEY: Record<IndustryPresetKey, IndustryPreset> = {
    horeca: "HORECA",
    beauty: "BEAUTY",
    fitness: "FITNESS",
    retail: "RETAIL",
    services: "SERVICES",
};

export function toLeadIndustryPreset(key: IndustryPresetKey): IndustryPreset {
    return LEAD_PRESET_BY_KEY[key];
}
